import { render, staticRenderFns } from "./StatusForSell.vue?vue&type=template&id=cbf54190&scoped=true&"
import script from "./StatusForSell.vue?vue&type=script&lang=js&"
export * from "./StatusForSell.vue?vue&type=script&lang=js&"
import style0 from "./StatusForSell.vue?vue&type=style&index=0&id=cbf54190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf54190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VContainer,VDialog,VProgressLinear})
